<template>
    <div class="caseApply">
        <div class="caseApplyHead">
            <!-- <div class="caseApplyTitle">病案复印助手</div> -->
            <van-steps :active="active" active-color="#fff">
                <van-step>复印申请</van-step>
                <van-step>身份认证</van-step>
                <van-step>复印信息</van-step>
                <van-step>支付结算</van-step>
            </van-steps>

        </div>
        <div class="caseApplyType">
            <a class="noticeIcon"></a>身份类型
        </div>
        <div class="caseApplyTypeNav" style="border-bottom: 1px solid #e4e4e4;">
            <span class="ApplyTypeNav" :class="selfFlag?'active':''" @click="selectIsNoSelf('1')">本人办理</span>
            <span class="ApplyTypeNav" :class="agentFlag?'active':''" @click="selectIsNoSelf('2')">代办人办理</span>
        </div>

        <!-- <div class="caseApplyType">身份认证</div> -->
        <div class="caseApplyTypeNav" @click="openType">

            <span class="IDCardTitle">证件类型</span>
            <span class="chooseHospital">{{ruleForm.typeName}}
                <van-icon name="arrow"/>
                </span>
        </div>
        <van-picker
                v-show="IDCardTypeFlag"
                show-toolbar
                title="证件类型"
                :columns="IDCardTypeList"
                value-key="name"
                @cancel="cancelType"
                @confirm="getType"
        />
        <div class="caseApplyType">
            <span>注意事项</span>
            <p>拍摄照片需信息清晰可见，手持照片需五官清晰，证件与身体保持平行</p>
            <div v-show="SFZFlag">
                <p v-show="selfFlag">第一张为身份证正面照，第二张为身份证反面照，第三张为手持身份证正面照</p>
                <p v-show="agentFlag">第一张为身份证正面照，第二张为身份证反面照，第三张为手持身份证正面照，第四张为患者本人出生医学证明、身份证、医保卡</p>
            </div>
            <div v-show="HKBFlag">
                <p v-show="selfFlag">第一张为户口本首页照，第二张为户口本人页照，第三张为手持户口本人页照</p>
                <p v-show="agentFlag">第一张为户口本首页照，第二张为户口本人页照，第三张为手持户口本人页照，第四张为患者本人出生医学证明、身份证、医保卡</p>
            </div>

        </div>
        <div class="caseApplyUpload" v-show="SFZFlag">
            <div class="uploadIDCardZ">
                <van-uploader :after-read="onRead">
                    <img class="head-img" src="../assets/images/idCard.png" name="photograph" ref="goodsImg"/>
                </van-uploader>
                <p v-if="selfFlag">身份证正面</p>
                <p v-if="agentFlag">代理人身份证正面</p>
            </div>
            <div class="uploadIDCardZ">
                <van-uploader :after-read="onRead1">
                    <img class="head-img" src="../assets/images/idCard1.png" name="photograph" ref="goodsImg1"/>
                </van-uploader>
                <p v-if="selfFlag">身份证反面</p>
                <p v-if="agentFlag">代理人身份证反面</p>
            </div>
        </div>
        <div class="caseApplyUpload" v-show="SFZFlag">
            <div class="uploadIDCardZ">
                <van-uploader :after-read="onRead2">
                    <img class="head-img" src="../assets/images/idCard2.png" name="photograph" ref="goodsImg2"/>
                </van-uploader>
                <P v-if="selfFlag">手持身份证正面</P>
                <P v-if="agentFlag">代理人手持身份证正面</P>
            </div>
            <div class="uploadIDCardZ" v-show="agentFlag">
                <van-uploader :after-read="onRead6">
                    <img class="head-img" src="../assets/images/idCard3.png" name="photograph" ref="goodsImg6"/>
                </van-uploader>
                <P>患者本人证件</P>
            </div>
        </div>
        <div class="caseApplyUpload" v-show="HKBFlag">
            <div class="uploadIDCardZ">
                <van-uploader :after-read="onRead3">
                    <img class="head-img" src="../assets/images/upload11.png" name="photograph" ref="goodsImg3"/>
                </van-uploader>
                <p v-if="selfFlag">户口本首页</p>
                <p v-if="agentFlag">代理人户口本首页</p>
            </div>
            <div class="uploadIDCardZ">
                <van-uploader :after-read="onRead4">
                    <img class="head-img" src="../assets/images/upload11.png" name="photograph" ref="goodsImg4"/>
                </van-uploader>
                <p v-if="selfFlag">户口本人页</p>
                <p v-if="agentFlag">代理人户口本人页</p>
            </div>
        </div>
        <div class="caseApplyUpload" v-show="HKBFlag">
            <div class="uploadIDCardZ">
                <van-uploader :after-read="onRead5">
                    <img class="head-img" src="../assets/images/upload11.png" name="photograph" ref="goodsImg5"/>
                </van-uploader>
                <P v-if="selfFlag">手持户口本人页</P>
                <P v-if="agentFlag">代理人手持户口本人页</P>
            </div>
            <div class="uploadIDCardZ" v-show="agentFlag">
                <van-uploader :after-read="onRead7">
                    <img class="head-img" src="../assets/images/idCard3.png" name="photograph" ref="goodsImg7"/>
                </van-uploader>
                <P>患者本人证件</P>
            </div>
        </div>
        <ul id="caseApplyMessage">
            <li class="caseApplyMessage"><span>患者姓名</span><input type="text" v-model="ruleForm.patientName"
                                                                 placeholder="上传身份证自动填充" onchange="value = value.replace(/\d/g, '')"></li>
            <li class="caseApplyMessage"><span>身份证号</span><input type="text" @blur="checkID" v-model="ruleForm.IDCard"
                                                                 placeholder="上传身份证自动填充"></li>
            <li class="caseApplyMessage">
                <span>手机号码</span><input type="text" @blur="checkPhone" v-model="ruleForm.phoneNum" placeholder="请输入手机号">
                <van-button id="sendCodeBtn" slot="button" size="small" :disabled="!canClick"
                            :class="{'disabled': !canClick}"
                            type="primary" @click="sendCode">{{content}}
                </van-button>
            </li>

            <li class="caseApplyMessage">
                <span>验证码</span>
                <input type="text" oninput="if(value.length>4)value=value.slice(0,4)" v-model="ruleForm.codeNum"
                       placeholder="请输入验证码">
            </li>

        </ul>
        <div class="caseApplyFooter">
            <input type="button" value="下一步" :disabled="btnFlag" :class="btnFlag?'':'btnactive'"
                   @click="goGaseApplyThird">
        </div>
        <div class="caseApplyBg" v-show="IDCardTypeFlag" @click="cancelType"></div>
    </div>
</template>
<script>
    import {Toast} from 'vant'
    import ApiSetting from '@/assets/js/api'
    import tool from '@/assets/js/tool'

    export default {
        data() {
            return {
                active: 1,
                HKBFlag: false,
                SFZFlag: true,
                selfFlag: false,
                agentFlag: true,
                IDCardTypeFlag: false,
                IDCardTypeList: [
                    {name: '身份证', value: '1'},
                    {name: '户口本', value: '2'},
                ],
                ruleForm: {
                    identityType: '2',
                    typeName: '身份证',
                    idCardType: '1',
                    patientName: '',
                    phoneNum: '',
                    codeNum: '',
                    IDCard: '',
                    fileUrlList: [],
                    IDCardFlag: false,
                    phoneNumFlag: false,
                },
                content: '发送验证码',  // 按钮里显示的内容
                totalTime: 60,     //记录具体倒计时时间
                canClick: true, //添加canClick
                btnFlag: true,

            }
        },
        watch: {
            'ruleForm': {
                handler(newValue, oldValue) {
                    if (newValue.patientName == ''
                        || newValue.phoneNum == ''
                        || newValue.codeNum == ''
                        || newValue.codeNum.length < 4
                        || newValue.IDCard == ''
                        || newValue.fileUrlList.length <= 0) {
                        this.btnFlag = true
                    } else {
                        if (newValue.IDCardFlag && newValue.phoneNumFlag) {
                            this.btnFlag = false
                        } else {
                            this.btnFlag = true
                        }

                    }
                },
                deep: true
            }
        },
        methods: {
            selectIsNoSelf(str) {
                this.ruleForm.patientName = '';
                this.ruleForm.IDCard = '';
                if (str == '1') {
                    this.selfFlag = true
                    this.agentFlag = false
                    this.ruleForm.identityType = '1'
                } else if (str == '2') {
                    this.selfFlag = false
                    this.agentFlag = true
                    this.ruleForm.identityType = '2'
                }
                this.$refs.goodsImg.src = require('../assets/images/idCard.png')
                this.$refs.goodsImg1.src = require('../assets/images/idCard1.png')
                this.$refs.goodsImg2.src = require('../assets/images/idCard2.png')
                this.$refs.goodsImg3.src = require('../assets/images/upload11.png')
                this.$refs.goodsImg4.src = require('../assets/images/upload11.png')
                this.$refs.goodsImg5.src = require('../assets/images/upload11.png')
                this.$refs.goodsImg6.src = require('../assets/images/idCard3.png')
                this.$refs.goodsImg7.src = require('../assets/images/upload11.png')
            },
            checkID() {
                var _this = this
                var reg = /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)/
                if (!reg.test(this.ruleForm.IDCard)) {
                    Toast('身份证号格式错误')
                    this.ruleForm.IDCardFlag = false
                } else {
                    this.ruleForm.IDCardFlag = true
                }
            },
            checkPhone() {
                var _this = this
                if (!(/^1[3456789]\d{9}$/.test(this.ruleForm.phoneNum))) {
                    Toast('手机号格式错误')
                    this.ruleForm.phoneNumFlag = false
                } else {
                    this.ruleForm.phoneNumFlag = true
                }
            },
            cancelType() {
                this.IDCardTypeFlag = false
            },
            openType() {
                this.IDCardTypeFlag = true
            },
            getType(value) {
                this.ruleForm.typeName = value.name
                this.ruleForm.idCardType = value.value
                this.IDCardTypeFlag = false

                this.$refs.goodsImg.src = require('../assets/images/idCard.png')
                this.$refs.goodsImg1.src = require('../assets/images/idCard1.png')
                this.$refs.goodsImg2.src = require('../assets/images/idCard2.png')
                this.$refs.goodsImg3.src = require('../assets/images/upload11.png')
                this.$refs.goodsImg4.src = require('../assets/images/upload11.png')
                this.$refs.goodsImg5.src = require('../assets/images/upload11.png')
                this.$refs.goodsImg6.src = require('../assets/images/idCard2.png')
                this.$refs.goodsImg7.src = require('../assets/images/upload11.png')
                this.ruleForm.fileUrlList = []
                if (value.value == '1') {
                    this.HKBFlag = false
                    this.SFZFlag = true
                } else if (value.value == '2') {
                    this.HKBFlag = true
                    this.SFZFlag = false
                }

            },
            onRead(file) {
                var _this = this
                let img = new Image();
                img.src = file.content;
                img.onload = function () {
                    let newFile = tool.compress(img)
                    let param = new FormData()
                    param.append('file', newFile.file);
                    _this.uploadFileRequest(ApiSetting.uploadFront, param).then((res) => {
                        if (res.data.responseCode == '200') {
                            _this.$refs.goodsImg.src = newFile.content;
                            _this.ruleForm.fileUrlList[0] = res.data.data.imgUrl;

                            //TODO 区分未本人还是代理人
                            console.info("_this.ruleForm.identityType:::" + _this.ruleForm.identityType)
                            if (_this.ruleForm.identityType == '1') {
                                _this.ruleForm.patientName = res.data.data.name;
                                _this.ruleForm.IDCard = res.data.data.idcard;
                                _this.checkID();
                            }
                        } else if (res.data.responseCode == '0') {
                            Toast.fail('图片上传失败，' + res.data.msg)
                        } else {
                            Toast.fail('图片上传失败！')
                        }
                    })
                }
            },
            onRead1(file) {
                var _this = this
                let img = new Image();
                img.src = file.content;
                img.onload = function () {
                    let newFile = tool.compress(img)
                    let param = new FormData()
                    param.append('file', newFile.file)
                    _this.uploadFileRequest(ApiSetting.uploadback, param).then((res) => {
                        if (res.data.responseCode == '200') {
                            _this.$refs.goodsImg1.src = newFile.content
                            _this.ruleForm.fileUrlList[1] = res.data.data.imgUrl
                        } else if (res.data.responseCode == '0') {
                            Toast.fail('图片上传失败，' + res.data.msg)
                        } else {
                            Toast.fail('图片上传失败！')
                        }
                    })
                }
            },

            onRead2(file) {
                var _this = this
                let img = new Image();
                img.src = file.content;
                img.onload = function () {
                    let newFile = tool.compress(img);
                    let param = new FormData()
                    param.append('file', newFile.file)
                    _this.uploadFileRequest(ApiSetting.upload, param).then((res) => {
                        if (res.data.responseCode == '200') {
                            _this.$refs.goodsImg2.src = newFile.content
                            _this.ruleForm.fileUrlList[2] = res.data.data.imgUrl
                        } else {
                            Toast.fail('图片上传失败，请重新上传')
                        }
                    })
                }
            },
            onRead3(file) {
                var _this = this
                let img = new Image();
                img.src = file.content;
                img.onload = function () {
                    let newFile = tool.compress(img)
                    let param = new FormData()
                    param.append('file', newFile.file, newFile.file.name)
                    _this.uploadFileRequest(ApiSetting.upload, param).then((res) => {
                        if (res.data.responseCode == '200') {
                            _this.$refs.goodsImg3.src = newFile.content
                            _this.ruleForm.fileUrlList[0] = res.data.data.imgUrl
                        } else {
                            Toast.fail('图片上传失败，请重新上传')
                        }
                    })
                }
            },
            onRead4(file) {
                var _this = this
                let img = new Image();
                img.src = file.content;
                img.onload = function () {
                    let newFile = tool.compress(img)
                    let param = new FormData()
                    param.append('file', newFile.file)
                    _this.uploadFileRequest(ApiSetting.upload, param).then((res) => {
                        if (res.data.responseCode == '200') {
                            _this.$refs.goodsImg4.src = newFile.content
                            _this.ruleForm.fileUrlList[1] = res.data.data.imgUrl
                        } else {
                            Toast.fail('图片上传失败，请重新上传')
                        }
                    })
                }
            },
            onRead5(file) {
                var _this = this
                let img = new Image();
                img.src = file.content;
                img.onload = function () {
                    let newFile = tool.compress(img)
                    let param = new FormData()
                    param.append('file', newFile.file, newFile.file.name)
                    _this.uploadFileRequest(ApiSetting.upload, param).then((res) => {
                        if (res.data.responseCode == '200') {
                            _this.$refs.goodsImg5.src = file.content
                            _this.ruleForm.fileUrlList[2] = res.data.data.imgUrl
                        } else {
                            Toast.fail('图片上传失败，请重新上传')
                        }
                    })
                }
            },
            onRead6(file) {
                var _this = this
                let img = new Image();
                img.src = file.content;
                img.onload = function () {
                    let newFile = tool.compress(img)
                    let param = new FormData()
                    param.append('file', newFile.file, newFile.file.name)
                    _this.uploadFileRequest(ApiSetting.upload, param).then((res) => {
                        if (res.data.responseCode == '200') {
                            _this.$refs.goodsImg6.src = file.content
                            _this.ruleForm.fileUrlList[3] = res.data.data.imgUrl
                        } else {
                            Toast.fail('图片上传失败，请重新上传')
                        }
                    })
                }
            },
            onRead7(file) {
                var _this = this
                let img = new Image();
                img.src = file.content;
                img.onload = function () {
                    let newFile = tool.compress(img)
                    let param = new FormData()
                    param.append('file', newFile.file, newFile.file.name)
                    _this.uploadFileRequest(ApiSetting.upload, param).then((res) => {
                        if (res.data.responseCode == '200') {
                            _this.$refs.goodsImg7.src = file.content
                            _this.ruleForm.fileUrlList[3] = res.data.data.imgUrl
                        } else {
                            Toast.fail('图片上传失败，请重新上传')
                        }
                    })
                }
            },
            countDown() {
                if (!this.canClick) return  //改动的是这两行代码
                this.canClick = false
                this.content = this.totalTime + 's后重新发送'
                let clock = window.setInterval(() => {
                    this.totalTime--
                    this.content = this.totalTime + 's后重新发送'
                    if (this.totalTime < 0) {
                        window.clearInterval(clock)
                        this.content = '重新发送验证码'
                        this.totalTime = 10
                        this.canClick = true  //这里重新开启
                    }
                }, 1000)
            },
            sendCode() {
                if (this.ruleForm.phoneNum == '') {
                    this.checkPhone()
                    return
                } else {
                    var param = {
                        cellphone: this.ruleForm.phoneNum
                    }
                    this.postRequest(ApiSetting.sendValidateCode, param).then((res) => {
                        if (res.data.responseCode == '200') {
                            this.countDown()
                            this.hospitalList = res.data.data
                        }
                    })
                }

            },
            goGaseApplyThird() {
                sessionStorage.setItem('casePersonMessage', JSON.stringify(this.ruleForm))
                var hospitalObj = JSON.parse(sessionStorage.getItem('obj'))
                if (hospitalObj.copyFlag == '1') {
                    this.$router.push({path: '/caseApplyThird1'})
                } else {
                    this.$router.push({path: '/caseApplyThird'})
                }
            },
            changeValue() {
                let leng = this.validateTextLength(this.groupName)
                if (leng >= 15) {
                    this.$refs.groupName.maxLength = leng
                } else {
                    this.$refs.groupName.maxLength = 30
                }
            },
            validateTextLength(value) {
                // 中文、中文标点、全角字符按1长度，英文、英文符号、数字按0.5长度计算
                let cnReg = /([\u4e00-\u9fa5]|[\u3000-\u303F]|[\uFF00-\uFF60])/g
                let mat = value.match(cnReg)
                let length
                if (mat) {
                    length = (mat.length + (value.length - mat.length) * 0.5)
                    return length
                } else {
                    return value.length * 0.5
                }
            }
        }
    }
</script>
<style lang="less" scoped>
    #sendCodeBtn {
        /deep/
        span {
            height: 0.74rem;
            line-height: 0.74rem;
        }
    }

    .noticeIcon {
        margin-top: 0.16rem;
        height: 0.48rem;
        width: 0.48rem;
        float: left;
        display: inline-block;
        background: url('../assets/images/personType.png') no-repeat;
        background-size: 100%;
        margin-right: 0.1rem;
    }

    .ApplyTypeNav {
        width: 2rem;
        height: 0.8rem;
        line-height: 0.82rem;
        display: inline-block;
        background: #dfdfdf;
        margin-left: 0.2rem;
        text-align: center;
        color: #333333;
        border-radius: 0.1rem;

        &.active {
            background: #1C84F2;
            color: #ffffff
        }
    }

    .van-picker {
        position: fixed;
        width: 100%;
        z-index: 99;
        bottom: 0;
        left: 0;
    }

    .disabled {
        background-color: #cccccc !important;
        border-color: #cccccc !important;
        color: #1C84F2 !important;
    }

    /deep/
    .van-button__text {
        margin-top: 0rem !important;
    }

    .caseApplyHead {
        border-bottom: 1px solid #e4e4e4;
    }

    #caseApplyMessage li {
        /deep/
        .van-cell__title {
            max-width: 1.16rem;
            margin-right: 0.2rem;
            font-size: 0.24rem;
        }

        /deep/
        .van-field__control {
            font-size: 0.24rem;
            left: 0.46rem;
            position: relative;
        }

        .van-button--primary {
            color: #fff;
            background-color: #1C84F2;
            border: 1px solid #1C84F2;
            border-radius: 0.1rem;
            float: right;
            margin-right: 0.2rem;
            height: 0.8rem;
            margin-top: 0.1rem;
        }
    }

    .van-cell {
        padding: 0;
        padding-left: 0.2rem;
        height: 0.8rem;
        line-height: 0.8rem;

        /deep/
        .van-field__button {
            padding-right: 0.2rem !important;
        }

        .van-button--primary {
            color: #fff;
            background-color: #1C84F2;
            border: 1px solid #1C84F2;
            border-radius: 0.1rem;
        }
    }

    .caseApplyType {
        line-height: 0.8rem;
        height: auto;

        p {
            margin-top: 0.2rem;
            margin-bottom: 0;
            margin-right: 0.2rem;
            line-height: 0.4rem;
        }

        span {
            margin-top: 0.2rem;
            display: block;
            width: 1.4rem;
            height: 0.4rem;
            line-height: 0.4rem;
            background: #1C84F2;
            color: #fff;
            text-align: center;
            border-radius: 0.1rem;
        }
    }

    .caseApplyTypeNav {
        .chooseHospital {
            float: right;
            margin-right: 0.2rem;
            font-size: 0.28rem;
            color: #1C84F2;
        }

        .IDCardTitle {
            display: inline-block;
            margin-left: 0.58rem;
            color: #333333;
        }

        .van-icon {
            position: relative;
            top: 0.04rem;
        }

    }

    .caseApplyUpload {
        background: #fff;
        height: 2.8rem;
        line-height: 1.2rem;
        width: 1.6rem;
        text-align: center;
        width: 100%;
        border-bottom: 1px solid #e4e4e4;
        overflow: hidden;

        .uploadIDCardZ:first-child {
            margin-left: 0.2rem;
        }

        .uploadIDCardZ {
            color: #e4e4e4;
            height: 2rem;
            width: 46%;
            border: 1px solid #e4e4e4;
            margin-left: 0.1rem;
            float: left;
            margin-top: 0.2rem;
            position: relative;

            img {
                height: 2rem;
                width: 100%;
                border: none;
            }

            .van-icon {
                font-size: 0.6rem;
                position: absolute;
                left: 0.3rem;
                margin-top: 0.2rem;
                width: 1rem;
                height: 0.6rem;
            }

            .van-uploader {
                height: 2rem;
                width: 100%;
            }
        }

        p {
            margin: 0;
            font-size: 0.24rem;
            position: absolute;
            bottom: -0.5rem;
            color: #333333;
            width: 100%;
            margin-left: -0.06rem;
            height: 0.4rem;
            line-height: 0.4rem;
        }
    }

</style>

